import { FC } from "react";

import { displayOutcomeName } from "./helpers";

import { CourseOutcomeType } from "components/server-types";
import { OutcomeChip } from "mds/components/OutcomeChip";
import { useAppSelector } from "store/index";
import {
  selectCourseOutcomeAverageScoreForUserAndOutcomes,
  selectCurrentCourseId,
  selectCurrentUserId,
  selectOutcomeById,
} from "store/selectors";

export const CourseOutcomeAverageScore: FC<{
  courseOutcome: CourseOutcomeType;
  role?: "heading" | "listitem";
}> = ({ courseOutcome, role }) => {
  const userId = useAppSelector(selectCurrentUserId);
  const courseId = useAppSelector(selectCurrentCourseId);
  const outcome = useAppSelector((s) => selectOutcomeById(s, courseOutcome.outcome_id));
  const averageScore = useAppSelector((s) =>
    selectCourseOutcomeAverageScoreForUserAndOutcomes(s, courseOutcome.id, userId, courseId),
  );

  return (
    <OutcomeChip role={role} score={averageScore} size="m" title={displayOutcomeName(outcome)} />
  );
};
